import { PRIMARY_COLOR_COMPONENT_STYLES } from './core/_consts';
import { getPrimaryColorTokens, getSidebarColorTokens, getInterfaceBackgroundColor } from './core/_utils';
import { useInterfaceAppearance } from './useInterfaceAppearance';

export const InterfaceAppearanceStyles = () => {
  const { appearance } = useInterfaceAppearance();
  const primaryTokens = getPrimaryColorTokens(appearance.primary_color);
  const sidebarTokens = getSidebarColorTokens(appearance.sidebar_color, appearance.primary_color);
  const tokens = { ...primaryTokens, ...sidebarTokens };
  const backgroundColor = getInterfaceBackgroundColor(appearance.background_color);
  const colorEntries = Object.entries(tokens);
  const colorDeclarations = colorEntries.map(([name, value]) => `${name}: ${value};`);
  const declarations = colorDeclarations.join('\n');

  const contrastColor = tokens['--bs-primary-inverse'];
  const checkmarkSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill="none" stroke="${contrastColor}" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="m3 8 3 3 7-7"/></svg>`;
  const radioSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="-4 -4 8 8"><circle r="2" fill="${contrastColor}"/></svg>`;
  const switchThumbSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="-4 -4 8 8"><circle r="3" fill="${contrastColor}"/></svg>`;
  const indeterminateSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill="none" stroke="${contrastColor}" stroke-linecap="round" stroke-width="3" d="M3 8h10"/></svg>`;
  const checkmarkImage = `url("data:image/svg+xml,${encodeURIComponent(checkmarkSvg)}")`;
  const radioImage = `url("data:image/svg+xml,${encodeURIComponent(radioSvg)}")`;
  const switchThumbImage = `url("data:image/svg+xml,${encodeURIComponent(switchThumbSvg)}")`;
  const indeterminateImage = `url("data:image/svg+xml,${encodeURIComponent(indeterminateSvg)}")`;

  return (
    <style>{`
    :root, [data-bs-theme] { ${declarations} }
    [data-bs-theme='dark'] {
      --app-primary-text: var(--app-primary-text-dark);
      --app-primary-text-rgb: var(--app-primary-text-dark-rgb);
      --bs-app-bg-color: #000000;
    }
    :root:not([data-bs-theme='dark']) { --bs-app-bg-color: ${backgroundColor}; }
    #kt_app_sidebar { background-color: var(--app-sidebar-background); }
    #kt_app_sidebar .menu-link { --app-sidebar-link-color: var(--app-sidebar-foreground); }
    #kt_app_sidebar .menu-link:is(.active, :hover),
    #kt_app_sidebar .menu-item:is(.show, .here) > .menu-link {
      --app-sidebar-link-color: var(--app-sidebar-accent);
    }
    #kt_app_sidebar .menu-item .menu-link .menu-title,
    #kt_app_sidebar .menu-item .menu-link .menu-icon,
    #kt_app_sidebar .menu-item .menu-link .menu-icon i,
    #kt_app_sidebar .menu-item .menu-link > i { color: var(--app-sidebar-link-color) !important; }
    #kt_app_sidebar .menu-item .menu-heading { color: var(--app-sidebar-foreground) !important; }
    #kt_app_sidebar .menu-bullet .bullet { background-color: var(--app-sidebar-link-color) !important; }
    #kt_app_sidebar .menu-link.active, #kt_app_sidebar .menu-link:hover {
      background-color: var(--app-sidebar-active-background);
      box-shadow: inset 2px 0 var(--app-sidebar-accent);
    }
    #kt_app_sidebar .menu-arrow::after { background-color: var(--app-sidebar-link-color) !important; }
    #kt_app_sidebar .menu-sub-lg-dropdown { background-color: var(--app-sidebar-background); }
    #kt_app_sidebar .app-sidebar-logo { border-bottom-color: color-mix(in srgb, var(--app-sidebar-foreground) 20%, transparent); }
    #kt_app_sidebar {
      --app-primary-text: var(--app-sidebar-primary-text);
    }
    ${PRIMARY_COLOR_COMPONENT_STYLES}
    .form-check-input:checked,
    .form-check-input[type='checkbox']:indeterminate,
    .form-check.form-check-solid .form-check-input[type='checkbox']:indeterminate {
      background-color: var(--bs-primary);
      border-color: var(--bs-primary);
    }
    .form-check-input[type='checkbox']:checked { --bs-form-check-bg-image: ${checkmarkImage}; }
    .form-check-input[type='radio']:checked { --bs-form-check-bg-image: ${radioImage}; }
    .form-check-input[type='checkbox']:indeterminate { --bs-form-check-bg-image: ${indeterminateImage}; }
    .form-switch .form-check-input:checked,
    .form-switch.form-check-solid .form-check-input:checked {
      --bs-form-switch-bg: ${switchThumbImage};
      background-image: var(--bs-form-switch-bg);
    }
    .nav-pills {
      --bs-nav-pills-link-active-bg: var(--bs-primary);
      --bs-nav-pills-link-active-color: var(--bs-primary-inverse);
    }
  `}</style>
  );
};
